const pad = (value) => String(value).padStart(2, "0");
const dateKey = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

function parseDate(value) {
  const date = value?.toDate ? value.toDate() : value instanceof Date ? value : new Date(typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T12:00:00` : value);
  return value && Number.isFinite(date.getTime()) ? date : null;
}

// Count people with payroll input, never approval documents or individual shifts.
export function buildPayrollTrend(employees, shifts, bookings, now = new Date()) {
  const daily = new Map();
  const monthly = new Map();
  const employeeIds = new Set(employees.map((employee) => employee.id));
  const add = (key, employeeId) => {
    if (!daily.has(key)) daily.set(key, new Set());
    daily.get(key).add(employeeId);
    const month = key.slice(0, 7);
    if (!monthly.has(month)) monthly.set(month, new Set());
    monthly.get(month).add(employeeId);
  };
  const bookingsByShift = new Map();
  bookings.forEach((booking) => {
    if (!["approved", "reserved"].includes(booking.status) || !booking.userId) return;
    const id = String(booking.originalShiftId || booking.shiftId || "");
    if (!bookingsByShift.has(id)) bookingsByShift.set(id, []);
    bookingsByShift.get(id).push({ employeeId: booking.userId });
  });
  shifts.forEach((shift) => {
    const date = parseDate(shift.date);
    if (!date) return;
    const entries = shift.employees?.length ? shift.employees : [shift];
    [...entries, ...(bookingsByShift.get(String(shift.originalId || shift.id)) || [])].forEach((entry) => {
      if (entry.isObemannad || !employeeIds.has(entry.employeeId)) return;
      // A scheduled shift is payroll input even before its salary is approved.
      add(dateKey(date), entry.employeeId);
    });
  });
  const years = [...monthly.keys()].map((key) => Number(key.slice(0, 4)));
  const firstYear = Math.min(now.getFullYear(), ...years);
  const lastYear = Math.max(now.getFullYear(), ...years);
  const monthlyEmployees = employees.filter((employee) => employee.payroll?.savedSalaryTypeId && employee.payroll.savedPayType === "monthly" && Number(employee.payroll.savedPayAmount) > 0);
  const months = [];
  // Monthly salaries apply to calendar days, including days without shifts.
  for (let year = firstYear; year <= lastYear; year++) {
    for (let month = 0; month < 12; month++) {
      const period = `${year}-${pad(month + 1)}`;
      const ids = new Set(monthly.get(period));
      monthlyEmployees.forEach((employee) => ids.add(employee.id));
      months.push({ period, count: ids.size });
    }
  }
  return {
    months,
    daysForMonth(period) {
      const [year, month] = period.split("-").map(Number);
      const length = new Date(year, month, 0).getDate();
      return Array.from({ length }, (_, index) => {
        const key = `${period}-${pad(index + 1)}`;
        const ids = new Set(daily.get(key));
        monthlyEmployees.forEach((employee) => ids.add(employee.id));
        return { period: key, count: ids.size };
      });
    },
  };
}
